import { FC } from 'react'
import { Menu, MenuProps } from '@mui/material'

const MenuWrapper: FC<MenuProps> = ({ ...props }) => (
  <Menu {...props} />
)

export default MenuWrapper
